// String-literal param enums for the dashboard endpoints. The generated client types these
// params as plain `string`, so we mirror the backend's allowed values here for type-safety.

export const StatsRange = { D30: 'D30', M6: 'M6' } as const;
export type StatsRange = (typeof StatsRange)[keyof typeof StatsRange];

export const SortDir = { ASC: 'ASC', DESC: 'DESC' } as const;
export type SortDir = (typeof SortDir)[keyof typeof SortDir];

export const ShipmentRole = { CONSIGNEE: 'CONSIGNEE', CARRIER: 'CARRIER' } as const;
export type ShipmentRole = (typeof ShipmentRole)[keyof typeof ShipmentRole];

export const PartnerRole = { MY_COMPANY: 'MY_COMPANY', PARTNER: 'PARTNER' } as const;
export type PartnerRole = (typeof PartnerRole)[keyof typeof PartnerRole];

export const ShipmentTopSortBy = {
  NAME: 'NAME',
  SHIPMENTS: 'SHIPMENTS',
  TOTAL_COSTS: 'TOTAL_COSTS',
  EXTRA_COSTS: 'EXTRA_COSTS',
  PRICE_PER_KM: 'PRICE_PER_KM',
  PRICE_PER_UNIT: 'PRICE_PER_UNIT',
} as const;
export type ShipmentTopSortBy = (typeof ShipmentTopSortBy)[keyof typeof ShipmentTopSortBy];

export const ReservationLocationSortBy = {
  LOCATION: 'LOCATION',
  RAMP: 'RAMP',
  RESERVATIONS: 'RESERVATIONS',
  SCHEDULED_TIME: 'SCHEDULED_TIME',
  ACTUAL_TIME: 'ACTUAL_TIME',
} as const;
export type ReservationLocationSortBy = (typeof ReservationLocationSortBy)[keyof typeof ReservationLocationSortBy];

export const NotificationPartnerSortBy = {
  NAME: 'NAME',
  NOTIFICATIONS: 'NOTIFICATIONS',
  TOTAL_RELATED_PRICE: 'TOTAL_RELATED_PRICE',
} as const;
export type NotificationPartnerSortBy = (typeof NotificationPartnerSortBy)[keyof typeof NotificationPartnerSortBy];

export const CustomsDeclarationTopSortBy = {
  NAME: 'NAME',
  SHIPMENTS: 'SHIPMENTS',
} as const;
export type CustomsDeclarationTopSortBy = (typeof CustomsDeclarationTopSortBy)[keyof typeof CustomsDeclarationTopSortBy];